/* Page « Nos revendeurs » (sections/store-locator.liquid), 2026-09-11.
   1. Trouve la région de chaque revendeur à partir de sa position sur la carte
      (isPointInFill sur les chemins [data-region] de snippets/carte-france.liquid) :
      rien à saisir dans l'éditeur quand on ajoute un magasin.
   2. Regroupe la liste (rendue à plat côté serveur) par région : régions les plus
      fournies d'abord, revendeurs du nord au sud. Desktop : tout ouvert.
      Téléphone (< 750px) : une région par ligne, en accordéon.
   3. Relie carte et liste : survol ou focus d'un revendeur → épingle orange + bulle ;
      survol d'une épingle → ligne surlignée ; clic sur une région → région teintée.
   4. Recherche (2026-11-01) : ville, code postal, n° ou nom de département, région ou
      enseigne. Filtre la liste, masque les régions vides, estompe les autres épingles.
   Sans JS, la liste reste visible à plat et la carte affiche ses épingles. */
(function () {
  var MOBILE = window.matchMedia('(max-width: 749px)');

  /* Noms de départements, pour qu'une recherche « Pas-de-Calais » trouve un code postal en 62 */
  var DEPTS = {};
  ('01 Ain|02 Aisne|03 Allier|04 Alpes-de-Haute-Provence|05 Hautes-Alpes|06 Alpes-Maritimes|07 Ardèche|08 Ardennes|'
    + '09 Ariège|10 Aube|11 Aude|12 Aveyron|13 Bouches-du-Rhône|14 Calvados|15 Cantal|16 Charente|17 Charente-Maritime|'
    + '18 Cher|19 Corrèze|20 Corse Corse-du-Sud Haute-Corse 2A 2B|21 Côte-d\'Or|22 Côtes-d\'Armor|23 Creuse|24 Dordogne|'
    + '25 Doubs|26 Drôme|27 Eure|28 Eure-et-Loir|29 Finistère|30 Gard|31 Haute-Garonne|32 Gers|33 Gironde|34 Hérault|'
    + '35 Ille-et-Vilaine|36 Indre|37 Indre-et-Loire|38 Isère|39 Jura|40 Landes|41 Loir-et-Cher|42 Loire|43 Haute-Loire|'
    + '44 Loire-Atlantique|45 Loiret|46 Lot|47 Lot-et-Garonne|48 Lozère|49 Maine-et-Loire|50 Manche|51 Marne|'
    + '52 Haute-Marne|53 Mayenne|54 Meurthe-et-Moselle|55 Meuse|56 Morbihan|57 Moselle|58 Nièvre|59 Nord|60 Oise|'
    + '61 Orne|62 Pas-de-Calais|63 Puy-de-Dôme|64 Pyrénées-Atlantiques|65 Hautes-Pyrénées|66 Pyrénées-Orientales|'
    + '67 Bas-Rhin|68 Haut-Rhin|69 Rhône|70 Haute-Saône|71 Saône-et-Loire|72 Sarthe|73 Savoie|74 Haute-Savoie|75 Paris|'
    + '76 Seine-Maritime|77 Seine-et-Marne|78 Yvelines|79 Deux-Sèvres|80 Somme|81 Tarn|82 Tarn-et-Garonne|83 Var|'
    + '84 Vaucluse|85 Vendée|86 Vienne|87 Haute-Vienne|88 Vosges|89 Yonne|90 Territoire de Belfort|91 Essonne|'
    + '92 Hauts-de-Seine|93 Seine-Saint-Denis|94 Val-de-Marne|95 Val-d\'Oise').split('|').forEach(function (d) {
    DEPTS[d.slice(0, 2)] = d.slice(3);
  });

  /* Minuscules, sans accents, tirets et apostrophes changés en espaces */
  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[-'’.,]/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function init(root) {
    if (!root || root.dataset.rvReady) return;
    var svg = root.querySelector('.rv-svg');
    var mapBox = root.querySelector('[data-rv-map]');
    var tip = root.querySelector('[data-rv-tip]');
    var list = root.querySelector('[data-rv-list]');
    var box = root.querySelector('[data-rv-regions]');
    if (!svg || !list || !box) return;
    root.dataset.rvReady = '1';

    var regions = Array.prototype.slice.call(svg.querySelectorAll('.rv-rg[data-region]'));
    var pins = {};
    var pinEls = Array.prototype.slice.call(svg.querySelectorAll('.rv-pin'));
    pinEls.forEach(function (p) { pins[p.dataset.i] = p; });
    /* Épingles du nord dessinées d'abord : celles du sud passent devant, comme sur une vraie carte */
    pinEls.sort(function (a, b) { return parseFloat(a.dataset.y) - parseFloat(b.dataset.y); })
      .forEach(function (p) { p.parentNode.appendChild(p); });
    /* Revendeurs à la même adresse à l'échelle de la carte (ex. deux à Bordeaux, < 1 unité) :
       épingles écartées côte à côte, sinon l'une cache l'autre. La région reste celle de la vraie adresse. */
    var placed = [];
    pinEls.forEach(function (p) {
      var x = parseFloat(p.dataset.x), y = parseFloat(p.dataset.y);
      var cluster = null;
      placed.forEach(function (c) { if (!cluster && Math.abs(c.x - x) < 4 && Math.abs(c.y - y) < 4) cluster = c; });
      if (cluster) cluster.pins.push(p); else placed.push({ x: x, y: y, pins: [p] });
    });
    placed.forEach(function (c) {
      if (c.pins.length < 2) return;
      c.pins.forEach(function (p, k) {
        var nx = Math.round((c.x + (k - (c.pins.length - 1) / 2) * 13) * 10) / 10;
        p.dataset.x = nx;
        p.dataset.y = c.y;
        p.setAttribute('transform', 'translate(' + nx + ' ' + c.y + ')');
      });
    });
    var items = Array.prototype.slice.call(list.querySelectorAll('.rv-store'));
    var rows = {};

    function svgPoint(x, y) {
      var p = svg.createSVGPoint();
      p.x = x; p.y = y;
      return p;
    }
    function inside(path, x, y) {
      try { return path.isPointInFill(svgPoint(x, y)); } catch (e) { return false; }
    }
    /* Région d'un point ; les adresses en bord de mer peuvent tomber juste hors du
       contour simplifié : on tente de petits décalages, puis la région la plus proche. */
    function regionOf(x, y) {
      var offsets = [[0, 0], [6, 0], [-6, 0], [0, 6], [0, -6], [12, 0], [-12, 0], [0, 12], [0, -12]];
      for (var o = 0; o < offsets.length; o++) {
        for (var r = 0; r < regions.length; r++) {
          if (inside(regions[r], x + offsets[o][0], y + offsets[o][1])) return regions[r];
        }
      }
      var best = null, bestD = Infinity;
      regions.forEach(function (r) {
        var b = r.getBBox();
        var d = Math.hypot(b.x + b.width / 2 - x, b.y + b.height / 2 - y);
        if (d < bestD) { bestD = d; best = r; }
      });
      return best;
    }

    /* ---- Regroupement par région ---- */
    var groups = {};
    items.forEach(function (li) {
      var x = parseFloat(li.dataset.x), y = parseFloat(li.dataset.y);
      var reg = regionOf(x, y);
      var name = reg ? reg.getAttribute('data-region') : 'Autres';
      if (!groups[name]) groups[name] = { path: reg, items: [] };
      groups[name].items.push(li);
      var cp = (li.dataset.city.match(/\d{5}/) || [''])[0];
      li._rvCp = cp;
      li._rvText = ' ' + norm([li.dataset.shop, li.dataset.city, li.dataset.adr, name, DEPTS[cp.slice(0, 2)]].join(' ')) + ' ';
      rows[li.dataset.i] = li;
      if (reg) reg.classList.add('has');
    });
    var names = Object.keys(groups).sort(function (a, b) {
      return groups[b].items.length - groups[a].items.length || a.localeCompare(b, 'fr');
    });
    var grid = document.createElement('div');
    grid.className = 'rv-grid';
    names.forEach(function (name) {
      var g = groups[name];
      g.items.sort(function (a, b) { return parseFloat(a.dataset.y) - parseFloat(b.dataset.y); });
      var det = document.createElement('details');
      det.className = 'rv-group';
      det.open = !MOBILE.matches;
      var sum = document.createElement('summary');
      var h = document.createElement('h2');
      h.className = 'rv-group-name';
      /* Nom de la région seul (le nombre de revendeurs a été retiré le 2026-09-11) */
      h.innerHTML = '<span></span>';
      h.firstChild.textContent = name;
      sum.appendChild(h);
      det.appendChild(sum);
      var ul = document.createElement('ul');
      g.items.forEach(function (li) { ul.appendChild(li); });
      det.appendChild(ul);
      sum.addEventListener('click', function (e) {
        if (!MOBILE.matches) e.preventDefault(); /* desktop : on reste ouvert, on teinte la région */
        select(g.path);
      });
      g.det = det;
      grid.appendChild(det);
    });
    list.remove();
    box.appendChild(grid);

    /* ---- Recherche ---- */
    var search = root.querySelector('[data-rv-search]');
    var input = root.querySelector('[data-rv-q]');
    var status = root.querySelector('[data-rv-status]');
    function matches(li, q) {
      /* Chiffres seuls : début du code postal (« 62 », « 440 », « 44000 ») */
      if (/^\d+$/.test(q)) return li._rvCp.indexOf(q) === 0;
      if (q === '2a' || q === '2b') return li._rvCp.indexOf('20') === 0;
      /* Sinon chaque mot doit commencer un mot de la fiche (« pas de calais », « bord ») */
      return q.split(' ').every(function (w) { return li._rvText.indexOf(' ' + w) !== -1; });
    }
    function filter() {
      var raw = input.value.trim();
      var q = norm(raw);
      var found = 0, last = null;
      names.forEach(function (name) {
        var g = groups[name], n = 0;
        g.items.forEach(function (li) {
          var ok = !q || matches(li, q);
          li.hidden = !ok;
          if (pins[li.dataset.i]) pins[li.dataset.i].classList.toggle('off', !ok);
          if (ok) { n++; last = li; }
        });
        found += n;
        g.det.hidden = n === 0;
        g.det.open = q ? n > 0 : !MOBILE.matches;
      });
      if (!q) status.textContent = '';
      else if (!found) status.textContent = 'Aucun revendeur trouvé pour « ' + raw + ' »';
      else status.textContent = found + (found > 1 ? ' revendeurs trouvés' : ' revendeur trouvé');
      /* Un seul résultat : son épingle s'allume sur la carte */
      on(found === 1 && !MOBILE.matches ? last.dataset.i : null);
    }
    if (search && input && status) {
      search.hidden = false;
      input.addEventListener('input', filter);
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && input.value) { input.value = ''; filter(); }
      });
    }

    /* Audit 2026-11-03-3 (C03) : passage mobile ↔ large (rotation, fenêtre agrandie).
       En large, les régions sont toujours ouvertes (leur titre n'ouvre plus rien) ;
       en mobile sans recherche, elles reviennent fermées comme au chargement. */
    function syncOpen() {
      var q = input ? norm(input.value.trim()) : '';
      names.forEach(function (name) {
        var det = groups[name].det;
        if (!MOBILE.matches) det.open = true;
        else if (!q) det.open = false;
      });
    }
    if (MOBILE.addEventListener) MOBILE.addEventListener('change', syncOpen);
    else if (MOBILE.addListener) MOBILE.addListener(syncOpen);

    function select(path) {
      regions.forEach(function (r) { r.classList.toggle('sel', r === path); });
    }

    /* ---- Liaison carte / liste ---- */
    function showTip(li) {
      if (!tip) return;
      var pin = pins[li.dataset.i];
      if (!pin) return;
      var ctm = svg.getScreenCTM();
      if (!ctm) return;
      var p = svgPoint(parseFloat(pin.dataset.x), parseFloat(pin.dataset.y)).matrixTransform(ctm);
      var r = mapBox.getBoundingClientRect();
      tip.innerHTML = '<b></b><span></span>';
      tip.firstChild.textContent = li.dataset.shop;
      tip.lastChild.textContent = li.dataset.adr + ', ' + li.dataset.city;
      tip.style.left = (p.x - r.left) + 'px';
      tip.style.top = (p.y - r.top) + 'px';
      tip.hidden = false;
    }
    function on(i) {
      Object.keys(pins).forEach(function (k) { pins[k].classList.toggle('on', k === i); });
      Object.keys(rows).forEach(function (k) { rows[k].classList.toggle('on', k === i); });
      if (i != null && rows[i]) showTip(rows[i]); else if (tip) tip.hidden = true;
    }
    items.forEach(function (li) {
      li.addEventListener('mouseenter', function () { on(li.dataset.i); });
      li.addEventListener('mouseleave', function () { on(null); });
      li.addEventListener('focus', function () { on(li.dataset.i); });
      li.addEventListener('blur', function () { on(null); });
    });
    Object.keys(pins).forEach(function (i) {
      var pin = pins[i];
      pin.addEventListener('mouseenter', function () { on(i); });
      pin.addEventListener('mouseleave', function () { on(null); });
      /* Clic / toucher sur une épingle : ouvre sa région et amène la ligne à l'écran */
      pin.addEventListener('click', function () {
        var li = rows[i];
        if (!li) return;
        var det = li.closest('details');
        if (det && !det.open) det.open = true;
        on(i);
        if (MOBILE.matches) li.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
    window.addEventListener('resize', function () { if (tip) tip.hidden = true; });
  }

  /* Encart « adresse e-mail » du bandeau revendeurs : un clic copie l'adresse (et ne fait
     rien d'autre), « Copié » s'affiche 2 s (annoncé aux lecteurs d'écran). */
  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
    return new Promise(function (resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy') ? resolve() : reject(); } catch (e) { reject(e); }
      document.body.removeChild(ta);
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-rv-copy]') : null;
    if (!btn) return;
    var mail = btn.getAttribute('data-rv-copy');
    var status = btn.parentNode.querySelector('[data-rv-copy-status]');
    copyText(mail).then(function () {
      btn.classList.add('is-copied');
      if (status) status.textContent = 'Adresse copiée';
      clearTimeout(btn._rvT);
      btn._rvT = setTimeout(function () { btn.classList.remove('is-copied'); if (status) status.textContent = ''; }, 2000);
    }, function () {
      /* Copie refusée par le navigateur (ex. aperçu dans un cadre) : on n'ouvre JAMAIS la
         messagerie (retour utilisateur du 2026-09-11), on sélectionne l'adresse pour ⌘C. */
      var txt = btn.querySelector('.rv-copy-mail');
      if (txt && window.getSelection) {
        var range = document.createRange();
        range.selectNodeContents(txt);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      }
      if (status) status.textContent = 'Adresse sélectionnée, appuyez sur Cmd ou Ctrl + C pour la copier';
    });
  });

  function scan() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-rv]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  /* Éditeur de thème : la section est re-rendue à chaque modification */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target.querySelector('[data-rv]'));
  });
})();
